module.exports = {"id":"189511","name":"Sergio Busquets","rating":"87","photo":"./data/images/photos/1/189511.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergioBusquets0.json
// module id = 3916
// module chunks = 0